import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Ribbon from "./components/Ribbon";
import Manifesto from "./components/Manifesto";
import Services from "./components/Services";
import Shop from "./components/Shop";
import Story from "./components/Story";
import ProfileCTA from "./components/ProfileCTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Admin from "./pages/Admin";
import Menu from "./pages/Menu";
import Gallery from "./pages/Gallery";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <CartProvider>
      <div className="App" data-testid="app-root">
        <Nav />
        <main>
          <Hero />
          <Ribbon />
          <Manifesto />
          <Services />
          <Shop />
          <Story />
          <ProfileCTA />
          <Contact />
        </main>
        <Footer />
        <CartDrawer />
      </div>
    </CartProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
